import { BaseClient } from './base-client';
import {
  Reminder,
  ReminderLog,
  CreateReminderRequest,
  UpdateReminderRequest,
  TriggerReminderResponse,
  CronApiConfig,
} from './types';

export class RemindersClient extends BaseClient {
  constructor(config: CronApiConfig) {
    super(config);
  }

  /**
   * Get all reminders
   */
  public async getAll(): Promise<Reminder[]> {
    return this._get<Reminder[]>('/api/reminders');
  }

  /**
   * Get a reminder by ID
   */
  public async getById(id: string): Promise<Reminder> {
    return this._get<Reminder>(`/api/reminders/${id}`);
  }

  /**
   * Create a new reminder
   */
  public async create(reminder: CreateReminderRequest): Promise<Reminder> {
    return this._post<Reminder>('/api/reminders', reminder);
  }

  /**
   * Update an existing reminder
   */
  public async update(reminder: UpdateReminderRequest): Promise<Reminder> {
    return this._put<Reminder>(`/api/reminders/${reminder.id}`, reminder);
  }

  /**
   * Delete a reminder
   */
  public async delete(id: string): Promise<void> {
    return this._delete<void>(`/api/reminders/${id}`);
  }

  /**
   * Get logs for a specific reminder
   */
  public async getLogs(id: string): Promise<ReminderLog[]> {
    return this._get<ReminderLog[]>(`/api/reminders/${id}/logs`);
  }

  /**
   * Manually trigger a reminder
   */
  public async trigger(id: string): Promise<TriggerReminderResponse> {
    return this._post<TriggerReminderResponse>(`/api/reminders/${id}/trigger`);
  }

  /**
   * Get all reminder logs across all reminders
   */
  public async getAllLogs(): Promise<ReminderLog[]> {
    return this._get<ReminderLog[]>('/api/reminder-logs');
  }
}
